<template>
  <div class="club-dashboard">
    <dashboard-charts :setLoading="setLoading" />
    <LoadingOverlay :loading="isLoading"  />
  </div>
</template>

<script>
import { mapMutations } from 'vuex';
import DashboardCharts from '@/views/Dashboard/DashboardCharts.vue'
import LoadingOverlay from '../../../components/LoadingOverlay.vue';
import { linkify } from '@/utils/safeHtml';

export default {
  name: "ClubDashboard",
  components: {DashboardCharts, LoadingOverlay},
  data() {
    return {
      monthNames: [
        this.$t('months.jan'),
        this.$t('months.feb'),
        this.$t('months.mar'),
        this.$t('months.apr'),
        this.$t('months.may'),
        this.$t('months.jun'),
        this.$t('months.jul'),
        this.$t('months.aug'),
        this.$t('months.sep'),
        this.$t('months.oct'),
        this.$t('months.nov'),
        this.$t('months.dec')
      ],
      overlayAddPost: false,
      overlayDeletePost: false,
      currentPost: null,
      isLoading: false
    };
  },
  mounted() {
    this.init();
  },
  watch: {
  },
  methods: {
    ...mapMutations(['setClubPosts']),
    linkify(inputText) {
      // HTML-escapes user text before adding anchors (stored-XSS fix)
      return linkify(inputText);
    },
    deletePost(post) {
      this.currentPost = post;
      this.overlayDeletePost = true;
    },
    setLoading(value){
      this.isLoading = value;
    }
  },
}
</script>



<style scoped>
  .button-add {
    background-color: #111111 !important;
    color: #ffffff !important;
    border: #111111 solid 1px;
  }
  .club-dashboard {
    padding: 1rem;
  }
</style>
